import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";

export interface LegalSection {
  heading: string;
  paragraphs?: string[];
  list?: string[];
}

interface LegalPageProps {
  title: string;
  subtitle: string;
  crumbs: { label: string; to?: string }[];
  sections: LegalSection[];
}

export default function LegalPage({ title, subtitle, crumbs, sections }: LegalPageProps) {
  return (
    <Layout>
      <PageHero title={title} subtitle={subtitle} crumbs={crumbs} />
      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <div className="space-y-8">
            {sections.map((section) => (
              <article key={section.heading}>
                <h2 className="font-heading text-xl font-semibold text-foreground-950">{section.heading}</h2>
                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph.slice(0, 30)} className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
                    {paragraph}
                  </p>
                ))}
                {section.list ? (
                  <ul className="mt-3 space-y-2.5">
                    {section.list.map((item) => (
                      <li key={item} className="flex items-start gap-3 font-body text-sm text-foreground-700">
                        <span className="mt-1.5 h-1.5 w-1.5 flex-none rounded-full bg-accent-500" aria-hidden="true"></span>
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </article>
            ))}
          </div>
          <p className="mt-10 border-t border-background-200 pt-6 font-body text-xs text-foreground-500">
            This page is provided for general information and should be reviewed by the clinic before publication.
          </p>
        </div>
      </section>
    </Layout>
  );
}